// RanksScreen (§4 Ranks tab) — leaderboards for Free Forge / Time Attack /
// Gauntlet, reusing the existing getLeaderboard service.
import { AD_SLOTS } from "../../config/adSlots";
import React, { useEffect, useState } from "react";
import Screen from "../ui/Screen";
import { Chip } from "../ui/primitives";
import { getLeaderboard } from "../../services/firebaseService";
import { useElementStore } from "../../store/elementStore";
import { levelFromDiscovered, getStreak } from "../../game/stats";

type LeaderboardEntry = Awaited<ReturnType<typeof getLeaderboard>>[number];

const TABS = [
  { key: "Free Forge", label: "Free Forge" },
  { key: "Time Attack", label: "Time Attack" },
  { key: "Gauntlet", label: "Gauntlet" },
];

const RanksScreen: React.FC = () => {
  const [tab, setTab] = useState(TABS[0].key);
  const [entries, setEntries] = useState<LeaderboardEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const discovered = useElementStore((s) => s.unlocked.size);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getLeaderboard(tab, 25)
      .then((list) => { if (!cancelled) setEntries(list); })
      .catch(() => { if (!cancelled) setEntries([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [tab]);

  const rankColor = (i: number) => (i === 0 ? "#F5B740" : i === 1 ? "#C0C7D9" : i === 2 ? "#D08B5B" : "var(--text-3)");

  return (
    <Screen title="Ranks" active="ranks" streak={getStreak().streak} level={levelFromDiscovered(discovered)} ad={AD_SLOTS.codex}>
      <div className="mc-in" style={{ padding: 16, display: "flex", flexDirection: "column", gap: 14 }}>
        <div style={{ display: "flex", gap: 8 }}>
          {TABS.map((t) => <Chip key={t.key} label={t.label} active={tab === t.key} onClick={() => setTab(t.key)} />)}
        </div>

        {loading ? (
          <div style={{ padding: 32, textAlign: "center", color: "var(--text-3)" }}>Loading…</div>
        ) : entries.length === 0 ? (
          <div style={{ padding: 32, textAlign: "center", color: "var(--text-3)", fontSize: 14 }}>
            No scores yet for {tab}. Be the first to top the board!
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {entries.map((e, i) => (
              <div key={`${e.userId}-${i}`} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", borderRadius: 14, background: "var(--surface)", border: "1px solid var(--border)" }}>
                <span style={{ width: 24, textAlign: "center", fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, color: rankColor(i) }}>{i + 1}</span>
                <div style={{ width: 34, height: 34, flex: "0 0 auto", borderRadius: "50%", background: "radial-gradient(circle at 34% 28%, var(--accent-text), #65A30D 60%, #3F6212)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, color: "#fff", fontSize: 14 }}>
                  {(e.username || "?")[0].toUpperCase()}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{e.username || "Anonymous"}</div>
                </div>
                <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 16, fontWeight: 700, color: "var(--accent-text)" }}>{e.score}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </Screen>
  );
};

export default RanksScreen;
